import React from 'react';
import './Badge.css';
import TradeArrow from "../TradeArrow/TradeArrow";

const Badge = ({ children, className = '' }) => {
  return (
    <div className={`badge ${className}`}>
      <span>{children}</span>
      <TradeArrow />
    </div>
  );
};

export default Badge;
